<div class="text-center">

  <mat-icon>book</mat-icon>
  <h1 *ngIf="_slot.booked === 0; else noTitleCreate" mat-dialog-title translate>dialog.slot.prenotation.create.title</h1>
  <ng-template #noTitleCreate>
    <h1 mat-dialog-title translate>dialog.slot.prenotation.update.title</h1>
  </ng-template>

  <div class="card container text-center p-2">

    <h5 class="text-primary">{{site.name}}</h5>

    <br>

    <h6 class="text-secondary">{{service.name}}</h6>

  </div>

  <div class="modal-body mt-3" mat-dialog-content>

    <div class="card container">

      <div class="row mt-3">

        <ng-container *ngIf="isAQP">

          <div class="col-md">
            <mat-form-field class = "full-width">
              <mat-label translate>dialog.slot.prenotation.generic.name</mat-label>
              <input [(ngModel)]="_slot.name" matInput>
            </mat-form-field>
          </div>

          <div class="col-md">
            <mat-form-field class = "full-width">
              <mat-label translate>dialog.slot.prenotation.generic.surname</mat-label>
              <input [(ngModel)]="_slot.surname" matInput>
            </mat-form-field>
          </div>

        </ng-container>

        <ng-container *ngIf="!isAQP">

          <div class="col-md">
            <mat-form-field class = "full-width">
              <mat-label translate>dialog.slot.prenotation.generic.identifier</mat-label>
              <input [(ngModel)]="_slot.identifier" matInput>
            </mat-form-field>
          </div>

        </ng-container>


      </div>

      <div class="row">

        <div class="col-md">
          <mat-form-field class = "full-width">
            <mat-label translate>dialog.slot.prenotation.generic.note</mat-label>
            <input [(ngModel)]="_slot.note" matInput>
          </mat-form-field>
        </div>

      </div>

      <ng-container *ngIf="isAQP">

        <div class="row">

          <div class="col-md">
            <mat-form-field class = "full-width">
              <mat-label translate>dialog.slot.prenotation.generic.phone</mat-label>
              <input [(ngModel)]="_slot.phone" matInput>
            </mat-form-field>
          </div>

        </div>

      </ng-container>

    </div>
  </div>

  <div class="modal-footer" mat-dialog-actions translate>

    <button type="button" class="btn btn-outline-danger" (click)="cancel()" translate>
      dialog.slot.generic.cancel
    </button>

    <button type="button" *ngIf="_slot.booked === 0; else noButtonCreate" class="btn btn-outline-secondary" (click)="create()" translate>
      dialog.slot.prenotation.create.action
    </button>

    <ng-template #noButtonCreate>
      <button type="button" class="btn btn-outline-secondary" (click)="update()" translate>
        dialog.slot.prenotation.update.action
      </button>
    </ng-template>
  </div>

</div>
